const RANKING = [
  { rank: 1, title: '都市恋爱法则', tag: '韩漫·恋爱', heat: '9.6', trend: 'up', change: '+2' },
  { rank: 2, title: '异世界食堂', tag: '日漫·美食', heat: '9.7', trend: 'stable', change: '-' },
  { rank: 3, title: '暗夜追踪者', tag: '韩漫·悬疑', heat: '9.5', trend: 'up', change: '+1' },
  { rank: 4, title: '剑道至尊', tag: '国漫·玄幻', heat: '9.4', trend: 'down', change: '-2' },
  { rank: 5, title: '凤倾天下', tag: '国漫·古风', heat: '9.3', trend: 'up', change: '+3' },
  { rank: 6, title: '星辰变', tag: '国漫·玄幻', heat: '9.2', trend: 'up', change: '+1' },
  { rank: 7, title: '秘密花园', tag: '韩漫·恋爱', heat: '9.1', trend: 'new', change: 'NEW' },
];

const RANK_BADGES: Record<number, string> = {
  1: 'bg-accent-500 text-background-50',
  2: 'bg-primary-500 text-background-50',
  3: 'bg-secondary-600 text-background-50',
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            人气榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            实时更新的漫画人气排行榜，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
            {RANKING.map((item, i) => (
              <a
                key={i}
                href="#cards"
                className={`flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                  i < RANKING.length - 1 ? 'border-b border-background-200/40' : ''
                }`}
              >
                <div className="w-8 shrink-0 flex items-center justify-center">
                  {item.rank <= 3 ? (
                    <span
                      className={`w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold ${RANK_BADGES[item.rank] || 'bg-foreground-400 text-background-50'}`}
                    >
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-sm font-semibold text-foreground-400">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 font-heading truncate">
                    {item.title}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{item.tag}</div>
                </div>

                <div className="shrink-0 flex items-center gap-3">
                  <span className="text-sm font-bold text-primary-600">{item.heat}</span>
                  <span
                    className={`text-xs font-semibold whitespace-nowrap ${
                      item.trend === 'up'
                        ? 'text-accent-600'
                        : item.trend === 'down'
                          ? 'text-foreground-400'
                          : item.trend === 'new'
                            ? 'text-primary-600'
                            : 'text-foreground-400'
                    }`}
                  >
                    {item.trend === 'up' && <i className="ri-arrow-up-s-line" />}
                    {item.trend === 'down' && <i className="ri-arrow-down-s-line" />}
                    {item.trend === 'stable' && <i className="ri-subtract-line" />}
                    {item.trend === 'new' && <i className="ri-sparkling-line" />}
                    {' '}{item.change}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}